module.exports = __webpack_public_path__ + "img/img0.a8917372.jpg";